export default "__VITE_ASSET__3498425a__"